import React, { useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate } from "react-router-dom";
import { RollbackOutlined } from "@ant-design/icons";
import { Layout, Col, Row } from "antd";
import { Button, Card, Form, Spin, Input } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { CREATE_TESTIMONIAL } from "../../constants/api";

function TestimonialAdd() {
  const { Content } = Layout;
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);

  const createData = (values) => {
    setIsLoading(true);
    const data = new FormData();
    data.append("name", values.name);
    data.append("description", values.description);
    data.append("company_name", values.company_name);
    data.append("link", values.link);

    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/testimonial");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(CREATE_TESTIMONIAL, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Create Testimonial"
            bordered={false}
            extra={
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loading}>
              <Form form={form} layout="vertical" onFinish={createData}>
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      name="name"
                      label="Name"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Name" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="company_name"
                      label="Company Name"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Company Name" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="link"
                      label="Link"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Link" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="description"
                      label="Description"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Description" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default TestimonialAdd;
